import { createQueryKeyStore } from '@lukemorales/query-key-factory';

export const referenceQueries = createQueryKeyStore({
  references: {
    templates: (districtId: number) => ({
      queryKey: [districtId],
    }),
    contacts: (candidateId: number) => ({
      queryKey: [candidateId],
    }),
    emailTemplates: (candidateId: number) => ({
      queryKey: [candidateId],
    }),
    completedAndDraft: (candidateId: number) => ({
      queryKey: [candidateId],
    }),
    pending: (candidateId: number) => ({
      queryKey: [candidateId],
    }),
  },
});
